// FastAPI 422 validation responses come back as `detail: [{loc, msg, ...}]`.
// Passing that array to setError → React renders an object child → blank
// white screen. Normalize whatever the backend sent into a single string.
export function formatApiError(err, fallback = "Something went wrong. Please try again.") {
  const detail = err?.response?.data?.detail;
  if (Array.isArray(detail)) {
    const msgs = detail.map((d) => d?.msg).filter(Boolean);
    if (msgs.length > 0) return msgs.join(", ");
  } else if (typeof detail === "string") {
    return detail;
  } else if (detail && typeof detail === "object") {
    if (typeof detail.msg === "string") return detail.msg;
    try {
      return JSON.stringify(detail);
    } catch {
      // fall through to fallback
    }
  }
  return fallback;
}
